<!--

Map
---

-->

<template>
    <div class="roads-container">
        <map-wrapper />
        <road-list
            @remove-road="onRemoveRoad" />
        <controls
            @render-road="onRenderRoad"
            @render-range="onRenderRange"
            @show-map="onShowMap" />
    </div>
</template>

<style lang="scss" scoped>

.roads-map, .roads-container {
    width: 100%;
    height: 100%;
}

</style>

<script>
    import RoadList from './RoadList.vue'
    import Controls from './Controls.vue'
    import MapWrapper from './MapWrapper.vue'
    import {mapActions, mapMutations} from 'vuex'
    import * as mi from '@/modules/map/interface.js'
    import * as Errors from '@/modules/errors.js'
    import {loadFoundIndex, getFoundIndex} from '@/modules/map/foundIndex.js'

    export default {
        components: {
            'road-list': RoadList,
            'controls': Controls,
            'map-wrapper': MapWrapper
        },
        computed: {
            visibleRoads() {
                return this.$store.state.roads.visibleRoads
            },
        },
        methods: {
            isVisible: function(number) {
                return this.visibleRoads.findIndex(
                    n => {return n == number}
                ) != -1
            },
            onRenderRoad: function(number) {
                const key = "A" + number

                const doRenderRoad = async () => {
                    const index = await getFoundIndex()
                    if (!(key in index)) {
                        Errors.none()
                        return
                    }
                    else if (index[key].found === false) {
                        Errors.notFound()
                        return
                    }
                    const road = await this.getRoad({number: number})
                    if (!this.isVisible(number)) {
                        this.pushVisibleRoad(number)
                        mi.processRoad(road.geojson, number)
                    }
                }

                doRenderRoad().then(() => this.setWorking(false))
            },
            onRenderRange: function(range) {
                let added = 0, requested = range.length

                const doRenderRange = async () => {
                    const index = await getFoundIndex()
                    range = range.filter(n => {return index["A" + n].found})
                    const roads = await this.getRange(range)
                    roads.forEach((r) => {
                        if (!this.isVisible(r.number)) {
                            this.pushVisibleRoad(r.number)
                            mi.processRoad(r.geojson, r.number)
                            added++
                        }
                    })
                }

                doRenderRange().then(() => {
                    this.setWorking(false)
                    if (added == 0) Errors.allNotFound()
                    else if (added < requested) Errors.someNotFound()
                })
            },
            onRemoveRoad(number) {
                mi.removeRoad(number)
                this.popVisibleRoad(number)
            },
            onShowMap: function(val) {
                let ml = mi.getMapLayer()
                if (val === true)
                    ml.setVisible(true)
                else
                    ml.setVisible(false)
            },
            ...mapActions('roads', ['getRoad', 'getRange']),
            ...mapMutations('roads', ['pushVisibleRoad', 'popVisibleRoad']),
            ...mapMutations('map', ['setActiveSource', 'setWorking'])
        },
        created() {
            this.setActiveSource('osmbw')
            loadFoundIndex()
        }
    }
</script>